import type { QueryClient } from "@tanstack/react-query";
import { baseCacheKeyPrefix } from "./makeCacheKeyPrefix";

export default function removeDataStoreQueries(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: [baseCacheKeyPrefix] });
}
